module.exports = __webpack_public_path__ + "static/media/col_camp_tennis_courts.dda9acb1.jpg";